import { store } from '@/store'

/**
 * 인증이 필요하지 않은 공개 라우트 목록
 */
const publicRoutes = ['/login', '/register', '/error', '/404', '/unauthorized']

/**
 * 인증 가드
 * - Session-based authentication (no localStorage token check)
 * - 권한 기반 접근 제어
 */
export const authGuard = (to, from, next) => {
  // 공개 라우트는 인증 불필요
  if (publicRoutes.includes(to.path)) {
    return next()
  }

  // Check login status from store (session-based)
  const isLoggined = store.getters['auth/isLoggined']

  if (!isLoggined) {
    // Not logged in, App.vue will show login UI
    return next()
  }

  // 권한 체크 (라우트 메타에 requiresPermission이 있는 경우)
  if (to.meta?.requiresPermission) {
    const permissions = store.getters['auth/permissions']
    const route = to.meta.permissionRoute || to.path

    // 권한 없으면 unauthorized 페이지로
    if (!permissions.includes(route)) {
      return next('/unauthorized')
    }
  }

  // 역할 체크 (라우트 메타에 requiresRole이 있는 경우)
  if (to.meta?.requiresRole) {
    const roles = store.getters['auth/roles']
    const requiredRoles = Array.isArray(to.meta.requiresRole)
      ? to.meta.requiresRole
      : [to.meta.requiresRole]

    // 필요한 역할 중 하나라도 있는지 확인
    const hasRole = requiredRoles.some((r) => roles.includes(r))
    if (!hasRole) {
      return next('/unauthorized')
    }
  }

  // 유효한 세션 + 권한 있음
  return next()
}

/**
 * 권한 체크 헬퍼 함수
 */
export const hasPermission = (route) => {
  const permissions = store.getters['auth/permissions']
  return permissions.includes(route)
}

export const hasRole = (roleName) => {
  const roles = store.getters['auth/roles']
  return roles.includes(roleName)
}

export const hasAnyRole = (roleNames) => {
  const roles = store.getters['auth/roles']
  return roleNames.some((r) => roles.includes(r))
}

/**
 * 페이지 타이틀 설정 가드
 */
export const titleGuard = (to, from, next) => {
  const defaultTitle = 'Token Management System'
  document.title = to.meta?.title || defaultTitle
  next()
}

/**
 * 에러 처리 가드
 */
export const errorGuard = (to, from, next) => {
  // 에러 상태 초기화
  store.commit('error/setValidationError', {})
  next()
}
